import useGetApplicationInitialValues from './useGetApplicationInitialValues'

export default useGetApplicationInitialValues
